import { z } from 'zod';
import { requiredString } from './common';

const reportCommentFields = {
  code: requiredString('Code'),
  description: requiredString('Description'),
};

export const createReportCommentSchema = z.object(reportCommentFields);
export type CreateReportCommentInput = z.infer<typeof createReportCommentSchema>;

export const updateReportCommentSchema = createReportCommentSchema;
export type UpdateReportCommentInput = z.infer<typeof updateReportCommentSchema>;
